import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import SitesService from '@/services/SitesService';

const objectType = 'adulticides';

class Adulticideservice extends BaseService {

  static getList(page = 1) {

    return super.get(`adulticides?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static siteSearch(search) {
    return SitesService.search(search);
  }

  static search(search, page) {

    return super.get(`adulticides/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static getDetails(id) {
    return super.get(`adulticides/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities['adulticides'][object.result['adulticides'][0]];
        data = camelizeKeys(data);

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {

    return super.post(objectType, `adulticides`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    return super.patch(objectType, `adulticides/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`adulticides/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default Adulticideservice;